import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { memoize } from '@infl-ts/util-function';
import { useToggle } from '@infl-ts/util-hooks';
import { logError, makeStreamError } from '@infl-ts/util-query-errors';
import { useTabChange } from '@infl-ts/util-use-tab-change';
import { constVoid, pipe } from 'fp-ts/function';
import * as T from 'fp-ts/Task';
import * as TE from 'fp-ts/TaskEither';
import { useCallback } from 'react';
import { StreamChat } from 'stream-chat';
var chatClientInstance = memoize(function (apiKey) {
  return StreamChat.getInstance(apiKey, {
    timeout: 6000
  });
});

var connectWS = function connectWS(client) {
  return pipe(client.wsConnection, TE.fromNullable(makeStreamError('Client has no WS Connection')), TE.chain(function (wsConnection) {
    return TE.tryCatch(function () {
      return wsConnection.connect();
    }, makeStreamError);
  }), TE.chainFirst(function () {
    return TE.tryCatch(function () {
      return client.recoverState();
    }, makeStreamError);
  }));
};

export var useHandleConnection = function useHandleConnection(_ref) {
  var shouldSkip = _ref.shouldSkip,
      apiKey = _ref.apiKey,
      _ref$onConnectSuccess = _ref.onConnectSuccess,
      onConnectSuccess = _ref$onConnectSuccess === void 0 ? constVoid : _ref$onConnectSuccess,
      _ref$onAlreadyConnect = _ref.onAlreadyConnected,
      onAlreadyConnected = _ref$onAlreadyConnect === void 0 ? constVoid : _ref$onAlreadyConnect;
  var chatClient = chatClientInstance(apiKey);
  var wsConnection = chatClient.wsConnection;

  var _useToggle = useToggle(wsConnection === null || wsConnection === void 0 ? void 0 : wsConnection.isDisconnected),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      isWSDisconnected = _useToggle2[0],
      _useToggle2$ = _useToggle2[1],
      wsDisconnect = _useToggle2$.on,
      wsConnect = _useToggle2$.off;

  var onHidden = useCallback(function () {
    !(wsConnection !== null && wsConnection !== void 0 && wsConnection.isDisconnected) && void (wsConnection === null || wsConnection === void 0 ? void 0 : wsConnection.disconnect());
    wsDisconnect();
  }, [wsConnection, wsDisconnect]);
  var onShow = useCallback(function () {
    if (wsConnection !== null && wsConnection !== void 0 && wsConnection.isDisconnected && !wsConnection.isConnecting) {
      void pipe(connectWS(chatClient), TE.matchEW(function (e) {
        return T.of(logError(e));
      }, function (res) {
        return T.fromIO(function () {
          onConnectSuccess(res);
          wsConnect();
        });
      }))();
    } else {
      onAlreadyConnected();
      wsConnect();
    }
  }, [chatClient, wsConnection, wsConnect, onConnectSuccess, onAlreadyConnected]);
  useTabChange({
    shouldSkip: shouldSkip,
    onHidden: onHidden,
    onShow: onShow
  });
  return isWSDisconnected;
};